module.exports = __webpack_public_path__ + "src/asset/svg/pattern.svg?4dc85b0c23a503cbbd75126a67d13c38";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/pattern.svg
// module id = 90
// module chunks = 0